var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"BIAnalysis"},[_c('back',{attrs:{"color":1}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }